export default __webpack_public_path__ + "static/media/selArrow.88648434.svg";